import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

import './WordsEditor.css'


class WordsEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      words: null,
    }
  }

  copyState() {
    const state = Object.assign({}, this.state)
    state.words = state.words === null ? null : state.words.map(w => w.slice())
    return state
  }

  getDuplicates() {
    const words = this.state.words || this.props.words
    const wordsSet = new Set(words.map(w => w[0]))
    let count = 0
    wordsSet.forEach(w => {
      if (words.filter(w_ => w_[0] === w).length > 1) {
        count += 1
      }
    })
    return count
  }

  wordsChange(wordIndex, candidateIndex, event) {
    const state = this.copyState()
    if (state.words === null) {
      state.words = this.props.words.map(w => w.map(v => v))
    }
    state.words[wordIndex][candidateIndex + 1] = event.target.value
    this.setState(state, () => {
      if (!this.props.onChange) {
        return
      }
      this.props.onChange(state.words)
    })
  }

  removeWord(wordIndex) {
    const state = this.copyState()
    if (state.words === null) {
      state.words = this.props.words.map(w => w.map(v => v))
    }
    state.words.splice(wordIndex, 1)
    this.setState(state, () => {
      if (!this.props.onChange) {
        return
      }
      this.props.onChange(state.words)
    })
  }

  removeDuplicates() {
    const state = this.copyState()
    if (state.words === null) {
      state.words = this.props.words.map(w => w.map(v => v))
    }
    state.words = state.words.filter((word, wordIndex) => {
      if (state.words.slice(0, wordIndex).some(w => w[0] === word[0])) {
        return false
      }
      return true
    })
    this.setState(state, () => {
      if (!this.props.onChange) {
        return
      }
      this.props.onChange(state.words)
    })
  }

  isTargetIssue(log, word) {
    if (!log.data.data) {
      return false
    }
    const data = JSON.parse(log.data.data)
    if (!data.word) {
      return false
    }
    if (!data.word.question) {
      return false
    }
    return data.word.question.text === word
  }

  changeResolved(event, word) {
    const logIds = (this.props.issueLogs || [])
      .filter(l => this.isTargetIssue(l, word))
      .map(l => l.id)
    console.log('RESOLVED', word)
    if (!this.props.onResolve) {
      return
    }
    this.props.onResolve(logIds, true)
  }

  renderIssues(word) {
    const issues = (this.props.issueLogs || []).filter(l => this.isTargetIssue(l, word[0]))
    const unresolved = issues.filter(l => !l.data.resolved).length
    return unresolved > 0 ?
      <Button
        variant='light'
        data-test-resolve-word-issues
        onClick={(ev) => this.changeResolved(ev, word[0])}>
        <Badge variant={unresolved === 0 ? 'default' : 'danger'}>{unresolved}</Badge>{' '}
        解決
      </Button> :
      '-'
  }

  render() {
    return <div className='WordsEditor'>
      {this.getDuplicates() > 0 && <Button
        variant='light'
        data-test-cell-words-remove-duplicates
        onClick={e => this.removeDuplicates()}>
        重複している単語を削除 ({this.getDuplicates()} 単語)
      </Button>}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>単語</th>
            <th>正解日本語</th>
            <th>不正解日本語1</th>
            <th>不正解日本語2</th>
            <th>不正解日本語3</th>
            <th>削除</th>
            <th>問題報告</th>
          </tr>
        </thead>
        <tbody>
          {(this.state.words || this.props.words).map((word, wordIndex) =>
            <tr key={`${word}-${wordIndex}`}>
              <td>{word[0]}</td>
              {[0, 1, 2, 3].map(index =>
                <td key={`${word}-${wordIndex}-${index}`}>
                  <Form.Control
                    data-test-task-word
                    placeholder={index === 0 ? '正解日本語' : `不正解日本語${index}`}
                    defaultValue={word[index + 1]}
                    onBlur={e => this.wordsChange(wordIndex, index, e)} />
                </td>
              )}
              <td>
                <Button
                  variant='light'
                  data-test-cell-words-remove
                  onClick={e => this.removeWord(wordIndex, e)}>
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </td>
              <td>
                {this.renderIssues(word)}
              </td>
            </tr>)}
        </tbody>
      </Table>
    </div>
  }
}

export default WordsEditor;
